export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/DnldIcon.e3be7840.svg","height":21,"width":20};